import { Grid, Card, CardContent } from "@common-ui/ui";

export const ProfileSidebar = (props) => {
  return (
    <Grid item md={2} sx={{ borderRight: "1px solid #EBEBEB" }}>
      <Card sx={{
        position: "sticky",
        top: "calc(55px)",
        height: "100vw"
      }}>
        <CardContent>
          {props.children}
        </CardContent>
      </Card>
    </Grid>
  );
}